import React, { useState } from 'react'
import { Link,  useNavigate } from 'react-router-dom';
 import { ToastContainer, toast } from "react-toastify";
 import "react-toastify/dist/ReactToastify.css";


const Login = () => {
    const [credentials, setCredentials] = useState({email: "",password: ""})
    const navigate = useNavigate();
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        
        const response = await fetch(
			"http://localhost:5000/api/auth/login",
			{
				method: "POST",
				headers: {
					"Content-type": "application/json",
				},
                body: JSON.stringify({email: credentials.email, password: credentials.password}),
			}
		);
        const json = await response.json();
        console.log(json);
        if(json){
            //Save the auth token and redirect 
            localStorage.setItem('token', json.authToken)
             toast.success("Logged in Successfully");
             window.dispatchEvent(new Event('storage')); // Trigger event listener in Navbar.tsx
            // navigate("/UserProfile");
navigate("/articles");



        }else{
             toast.error("Invalid credentials please login with correct credentials");
        }
    }
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setCredentials({...credentials, [e.target.name]: e.target.value})
	}
  return (
    <>
                     <ToastContainer
					position="top-center"
					autoClose={1000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
					theme="red"
				    />
				  <ToastContainer /> 
    <section className="bg-gray-50">
  <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
      <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
                  Login to your account
              </h1>
              <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6" action="#">
                  <div>
                      <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900">Email</label>
                      <input type="email" name="email" id="email" value={credentials.email} className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="Enter your email"  onChange={onChange}/>
                  </div>
                  <div>
                      <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 ">Password</label>
                      <input type="password" name="password" id="password" value={credentials.password} placeholder="••••••••" className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" onChange={onChange}/>
                  </div>
                  <div className="flex items-center justify-between">
                      <Link to="" className="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500">Forgot password?</Link>
                  </div>
                  <button type="submit" className="w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Log in</button>
                  <p className="text-sm font-light text-gray-500">
                      Don’t have an account yet? <Link to="/NewSignUp" className="font-medium text-blue-600 hover:underline hover:text-blue-800">Sign up</Link>
                  </p>
              </form>
             
          </div>
      </div>
  </div>
</section>
    </>
  )
}

export default Login;